import { render, staticRenderFns } from "./wxmenus.vue?vue&type=template&id=1b5177db&scoped=true&"
import script from "./wxmenus.vue?vue&type=script&lang=js&"
export * from "./wxmenus.vue?vue&type=script&lang=js&"
import style0 from "./wxmenus.vue?vue&type=style&index=0&id=1b5177db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5177db",
  null
  
)

export default component.exports